export default function Contact() {
    return (
        <div className="h-screen flex justify-center items-center bg-purple-300 ">
            <h1 className="md:text-9xl text-4xl font-black">コンタクト</h1>
        </div>
    )
}